import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import {
  REPORTS_LIST_PATH,
} from '../../../routing/paths.constants';
import { useStore } from '../../../../store';

export const ReportTableButton = (): JSX.Element => {
  const { mapReportDefinition } = useStore();
  return (
    <Link className="sidebar__link" to={`${REPORTS_LIST_PATH}/exec-${mapReportDefinition.data.reportdef_id}`}>
      <Button
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '8px',
          backgroundColor: '#F7F8FA',
          borderColor: '#190952',
        }}
        icon={(
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.900024 2.4999C0.900024 2.3066 1.05672 2.1499 1.25002 2.1499H3.75002C3.94332 2.1499 4.10002 2.3066 4.10002 2.4999V4.9999C4.10002 5.1932 3.94332 5.3499 3.75002 5.3499H1.25002C1.05672 5.3499 0.900024 5.1932 0.900024 4.9999V2.4999ZM1.60002 2.8499V4.6499H3.40002V2.8499H1.60002Z" fill="#001D66" />
            <path fillRule="evenodd" clipRule="evenodd" d="M0.900024 6.9999C0.900024 6.8066 1.05672 6.6499 1.25002 6.6499H3.75002C3.94332 6.6499 4.10002 6.8066 4.10002 6.9999V9.4999C4.10002 9.6932 3.94332 9.8499 3.75002 9.8499H1.25002C1.05672 9.8499 0.900024 9.6932 0.900024 9.4999V6.9999ZM1.60002 7.3499V9.1499H3.40002V7.3499H1.60002Z" fill="#001D66" />
            <path fillRule="evenodd" clipRule="evenodd" d="M5.40002 2.4999C5.40002 2.3066 5.55672 2.1499 5.75002 2.1499H10.75C10.9433 2.1499 11.1 2.3066 11.1 2.4999V4.9999C11.1 5.1932 10.9433 5.3499 10.75 5.3499H5.75002C5.55672 5.3499 5.40002 5.1932 5.40002 4.9999V2.4999ZM6.10002 2.8499V4.6499H10.4V2.8499H6.10002Z" fill="#001D66" />
            <path fillRule="evenodd" clipRule="evenodd" d="M5.40002 6.9999C5.40002 6.8066 5.55672 6.6499 5.75002 6.6499H10.75C10.9433 6.6499 11.1 6.8066 11.1 6.9999V9.4999C11.1 9.6932 10.9433 9.8499 10.75 9.8499H5.75002C5.55672 9.8499 5.40002 9.6932 5.40002 9.4999V6.9999ZM6.10002 7.3499V9.1499H10.4V7.3499H6.10002Z" fill="#001D66" />
          </svg>
        )}
      >
        <span style={{
          fontSize: '12px', fontWeight: 500, color: '#190952', marginLeft: '8px',
        }}
        >
          Report Table
        </span>
      </Button>
    </Link>
  );
};
